import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { useInitialPathname } from "../context/InitialRouteContext";
import { isHomePath } from "../utils/homePath";
import { HOME_LOADER_ENABLED } from "../config/homeLoader";

/**
 * Applies body scroll lock + loader-active before the lazy Home chunk mounts,
 * so header/cookies don’t paint ahead of the full-page loader (Loader lives inside Home).
 */
const LoaderBootstrap = () => {
  const { pathname } = useLocation();
  const initialPathname = useInitialPathname();
  const needsLoader =
    HOME_LOADER_ENABLED &&
    initialPathname != null &&
    isHomePath(pathname) &&
    isHomePath(initialPathname);

  useLayoutEffect(() => {
    if (!needsLoader) {
      // Fallback: clear pre-bootstrap loader lock injected in index.html
      // in case this route should render without home loader.
      document.body.classList.remove("loader-active");
      document.body.style.position = "";
      document.body.style.width = "";
      document.body.style.top = "";
      document.body.style.overflow = "";
      return undefined;
    }
    const scrollY = window.scrollY;
    document.body.classList.add("loader-active");
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    document.body.style.top = `-${scrollY}px`;

    return () => {
      document.body.classList.remove("loader-active");
      document.body.style.position = "";
      document.body.style.width = "";
      document.body.style.top = "";
      document.body.style.overflow = "";
    };
  }, [needsLoader]);

  return null;
};

export default LoaderBootstrap;
